import React from "react";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DesktopWindowsOutlinedIcon from "@mui/icons-material/DesktopWindowsOutlined";
import SmartphoneOutlinedIcon from "@mui/icons-material/SmartphoneOutlined";

function LearningPreviewMenuButton({
  onSelect,
  variant = "icon",
  tooltip = "Preview employee view",
  className = "",
  iconButtonSx = {},
}) {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const openMenu = (event) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const chooseDevice = (event, device) => {
    event.stopPropagation();
    setAnchorEl(null);
    onSelect && onSelect(device);
  };

  const button =
    variant === "button" ? (
      <button
        type="button"
        onClick={openMenu}
        className={
          className ||
          "inline-flex items-center gap-2 rounded-lg border border-slate-200 px-3 py-2 text-sm font-semibold text-slate-700 transition-colors hover:bg-slate-50"
        }
      >
        <VisibilityIcon style={{ fontSize: 18 }} />
        Preview
      </button>
    ) : (
      <IconButton
        size="small"
        onClick={openMenu}
        sx={iconButtonSx}
      >
        <VisibilityIcon style={{ fontSize: 18 }} />
      </IconButton>
    );

  return (
    <>
      <Tooltip title={tooltip}>
        <span>{button}</span>
      </Tooltip>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <MenuItem onClick={(event) => chooseDevice(event, "desktop")}>
          <ListItemIcon>
            <DesktopWindowsOutlinedIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText
            primary="Desktop"
            secondary="Browser-sized preview"
          />
        </MenuItem>
        <MenuItem onClick={(event) => chooseDevice(event, "mobile")}>
          <ListItemIcon>
            <SmartphoneOutlinedIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText
            primary="Mobile"
            secondary="Phone-sized preview"
          />
        </MenuItem>
      </Menu>
    </>
  );
}

export default LearningPreviewMenuButton;
